export const MAX_UPLOAD_SIZE_BYTES = 20 * 1024 * 1024; // 20MB